/** @jsxImportSource @emotion/react */
import { useRef, useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { SubTitleLayout, SubTitleGroup, GlobalBtnGroup } from 'components/layouts/ContentLayout';
import CustomDialog from 'components/modals/common/CustomDialog';
import { IconButton } from 'components/buttons/IconSVG';
import { useMessageBar } from 'hooks/useMessageBar';
import { SetupProjectManager } from 'models/setup/SetupProjectManager';
import { useLoading } from 'components/process/Loading';
import { ProjectExcp } from 'models/admin/ExcpPartner';
import _ from 'lodash';
import { tb } from 'components/layouts/Table';
import CustomGrid from 'components/grids/CustomGrid';

type Props = {
  open: boolean;
  close: () => void;
};

/**
 * 투자항목 추가 팝업
 */
const IvesInqPopup = ({ open, close, ...props }: Props) => {
  const { t } = useTranslation();
  const { openMessageBar } = useMessageBar();
  const { openLoading } = useLoading();

  const gridRef = useRef<any>();
  const [rowData, setRowData] = useState<ProjectExcp[]>([]);

  const layoutDefinition = useMemo(() => {
    return [
      {
        binding: 'excpNm',
        header: String(t('com.label.공장', '공장')),
        minWidth: 70,
        width: '*',
        align: 'left',
      },
      {
        binding: 'excpNm',
        header: String(t('com.label.설비', '설비')),
        minWidth: 70,
        width: '*',
        align: 'left',
      },
      {
        binding: 'excpNm',
        header: String(t('com.label.투자 항목', '투자 항목')),
        minWidth: 70,
        width: '*',
        align: 'left',
      },
    ];
  }, [rowData]);

  const onInitialized = (grid) => {
    gridRef.current = grid;
  };

  const initCodes = async () => {
    //
  };

  const btnSearch = () => {
    // search
  };

  const btnSave = () => {
    // save
  };

  useEffect(() => {
    initCodes();
  }, []);

  const dialogButtons = [
    <Button
      key={'confirm'}
      css={IconButton.button}
      className="confirm"
      onClick={btnSave}
      disableRipple
    >
      {t('com.button.선택', '선택')}
    </Button>,
  ];
  return (
    <CustomDialog
      title={String(t('setup.label.투자항목 리스트 조회', '투자항목 리스트 조회'))}
      size={'md'}
      open={open}
      onClose={close}
      onCancel={close}
      buttons={dialogButtons}
    >
      <SubTitleLayout>
        <SubTitleGroup>
          <h3>{t('setup.label.투자항목 목록', '투자항목 목록')}</h3>
        </SubTitleGroup>
      </SubTitleLayout>
      <CustomGrid
        layoutDefinition={layoutDefinition}
        rowData={rowData}
        height={500}
        isReadOnly={true}
        isFilter={false}
        autoCheck={true}
        allowPinning={false}
        align="center"
        initialized={onInitialized}
      />
    </CustomDialog>
  );
};

export default IvesInqPopup;
